<div class="info-container">
    <span class="game-name">Direccion de envio</span>
</div>
<div class="direccion-compra-desktop-wrapper">
    <app-direccion-compra-view></app-direccion-compra-view>
</div>